import { Translation } from '../../localization'

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ' as const
export const QUERY_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ' as const
export const GENERAL_DATA_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ' as const
export const DEFAULT_DATE_DISPLAY_FORMAT = 'D.M.YYYY' as const
export const DEFAULT_DATE_TIME_DISPLAY_FORMAT = `D.M.YYYY [${Translation.translateKey('klo')}] HH:mm` as const
